export class IdentityProvider {
    ssoLink: string;

    constructor(
        public denom: string = '',
        public dname: string = '',
        public name: string = '',
        public providerIdentifier: string = '',
        public enabled: boolean = false,
        public icon: string = ''
    ) {
    }

    setIconFromDenom() {
        if (IDPIconsMap.has(<IdentityProviderType>this.denom)) {
            this.icon = IDPIconsMap.get(<IdentityProviderType>this.denom);
        }
    }
}

export const ADD_IDP_ROUTE_ACTION = 'ADD_IDP';
export const LDAPDenomIdentityProvider = 'AUTH_PROVIDER_LDAP';
export const LTIDenomIdentityProvider = 'AUTH_PROVIDER_LTI';
export const PassportLoginDenomIdentityProvider = 'AUTH_PROVIDER_PASSPORT_LOGIN';

export enum IdentityProviderType {
    'AUTH_PROVIDER_ADFS' = 'AUTH_PROVIDER_ADFS',
    'AUTH_PROVIDER_AZURE_LOGIN' = 'AUTH_PROVIDER_AZURE_LOGIN',
    'AUTH_PROVIDER_CLEVER_LOGIN' = 'AUTH_PROVIDER_CLEVER_LOGIN',
    'AUTH_PROVIDER_GOOGLE_LOGIN' = 'AUTH_PROVIDER_GOOGLE_LOGIN',
    'AUTH_PROVIDER_FACEBOOK_LOGIN' = 'AUTH_PROVIDER_FACEBOOK_LOGIN',
    'AUTH_PROVIDER_LDAP' = 'AUTH_PROVIDER_LDAP',
    'AUTH_PROVIDER_LTI' = 'AUTH_PROVIDER_LTI',
    'AUTH_PROVIDER_QR_CODE' = 'AUTH_PROVIDER_QR_CODE',
    'AUTH_PROVIDER_SAML_IDP' = 'AUTH_PROVIDER_SAML_IDP',
    'AUTH_PROVIDER_PASSPORT_LOGIN' = 'AUTH_PROVIDER_PASSPORT_LOGIN',
    'AUTH_PROVIDER_FACEID_LOGIN' = 'AUTH_PROVIDER_FACEID_LOGIN',
}

export const LDAPIdentityProvider = new IdentityProvider(
    LDAPDenomIdentityProvider,
    LDAPDenomIdentityProvider,
    'Active Directory (LDAP)',
    'ldap'
);

export const PassportLoginIdentityProvider = new IdentityProvider(
    PassportLoginDenomIdentityProvider,
    PassportLoginDenomIdentityProvider,
    'SchoolDay Login',
    'passport_login',
    true,

);

const IDPIconsMap = new Map<IdentityProviderType, string>([
    [IdentityProviderType.AUTH_PROVIDER_ADFS, 'assets/images/logos/idp/ms-logo-color.svg'],
    [IdentityProviderType.AUTH_PROVIDER_AZURE_LOGIN, 'assets/images/logos/idp/ms-logo-color.svg'],
    [IdentityProviderType.AUTH_PROVIDER_CLEVER_LOGIN, 'assets/images/logos/idp/clever-logo.png'],
    [IdentityProviderType.AUTH_PROVIDER_GOOGLE_LOGIN, 'assets/images/logos/idp/google-logo-color.svg'],
    [IdentityProviderType.AUTH_PROVIDER_FACEBOOK_LOGIN, 'assets/images/logos/idp/facebook-logo-color.png'],
    [IdentityProviderType.AUTH_PROVIDER_QR_CODE, 'assets/images/logos/idp/qrcode.svg'],
    [IdentityProviderType.AUTH_PROVIDER_SAML_IDP, 'assets/images/logos/idp/saml.png'],
    [IdentityProviderType.AUTH_PROVIDER_PASSPORT_LOGIN, 'https://dejb1k265ab05.cloudfront.net/static/svg/icon-default.svg']
]);
